export const selectUserTopics = state => state.userTopics;

export const isLoadingSelectUserTopics = state => state.userTopics.isLoading;
